export const getIndicatorColor = indicator => {
  
  if(indicator < 0.9) {
    return "red";
  }
  if(indicator >= 1) {
    return "green"
  }
  return "yellow"
}